<template>
  <div class="event-group">
    <h2 class="event-group__title">{{ formattedDate }}</h2>
    <Event :key="event.id" :event="event" v-for="event in group.events"/>
  </div>
</template>

<script>
import Event from './Event'
import { parse, format } from 'date-fns'

export default {
  name: 'EventListGroup',

  components: {
    Event
  },

  props: {
    group: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    formattedDate() {
      return format(parse(this.group.date), 'MMMM Do')
    }
  }
}
</script>
